export default __webpack_public_path__ + "static/media/companyhome.942a84db.jpg";